export const iconFontAwesomeMusicVideoHeadphones = (
	<i className="fa-solid fa-headphones"></i>
);
